export default class Dev2Settings {
  production = false;

  stage = 'develop-2';

  // APR-3501 — marca do título da aba (regra em settings.ts); fora de produção vale pra todas.
  brandedPageTitle = true;

  citiesWhitelist = [
    {
      name: 'Aprovadesk - AD',
      identity: 'aprovadeskad',
      connection: 'AprovadeskAD',
    },
    {
      name: 'Modelo - AD',
      identity: 'modeload',
      connection: 'Username-Password-Authentication',
      loginUrl: '',
    },
  ];

  authenticationUrl = {
    v1: 'https://alt-develop-2.api.aprova.com.br/authentication-api/v1',
    v2: 'https://alt-develop-2.api.aprova.com.br/authentication/api/v2/users',
  };

  citiesUrl = {
    v1: 'https://alt-develop-2.api.aprova.com.br/cities',
  };

  usersUrl = {
    v2: 'https://alt-develop-2.api.aprova.com.br/users/v2',
  };

  integrationsUrl = {
    v1: 'https://alt-develop-2.api.aprova.com.br/integracoes-externas',
  };

  recaptcha = {
    siteKey: '6Les3sEUAAAAAEw59z-wAQOt8no3d500fFYdbLf0',
  };

  webpki = {
    apiKey:
      'AjsAKi5hcHJvdmEuY29tLmJyLCouYmJnb3Zlcm5vZGlnaXRhbC5jb20uYnIsKi5wcmVmZWl0dXJhcy5uZXRDAGlwNDoxMC4wLjAuMC84LGlwNDoxMjcuMC4wLjAvOCxpcDQ6MTcyLjE2LjAuMC8xMixpcDQ6MTkyLjE2OC4wLjAvMTYDAFBybwAAAAFIHZy7hX+Zt6sZlFtXYbaKc/fx7G3OaoGd8hhAljlcRRxSzCcUUpCAQGQg0E8emV0Et5wpaRokzxT7fh5dy286V141zARwvqRqhRh0k02kw5QRQf+f9/Oqb9ZsmPPcJIaCOPlPvqDKPIBW4aSdOZO8GVa+hphopQ9RDt0H9ZYjV0awgtzt2yRkonnL6tImFXUh6VMxGbtiCGGnEK0mTMdib8uzS4FbaYitVI7HzmySvo/M179bpH9a+qJz3UthF+cR3mAy7/t/rRUdpGyr06TsEE8uLRCtXKK9ZgKCbhDZEuc+IyBgTxDtSx4tq08EIu2XvH6JpYEBKwZuEWMQXCoC',
    pluginUrl:
      'https://chrome.google.com/webstore/detail/web-pki/dcngeagmmhegagicpcmpinaoklddcgon',
  };


  socialLogin = {
    google: {
      clientId:
        '151302971136-2qvflstuuqpe3j2f865bsrgh7cvjev02.apps.googleusercontent.com',
    },
  };

  intercom = {
    appId: 'ln2pzt2w',
  };
}
